module.exports = __webpack_public_path__ + "static/media/upload-to-cloud.3fcbc068.png";